/* tslint:disable */

/**
 */
export class Connection {
    ID_USER?: number;
    DATE_CONNECTION?: string;
    DATE_DISCONNECTION?: string;
    TYPE_DISCONNECTION?: string;
    USERNAM?: string;
    PERIOD?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/connection.ts